import React from 'react';
import { LandingContent } from 'components/LandingContent';
import noteLandingImage from 'assets/images/notes/notes-landing.jpeg';

const NoteLanding = ({ createNote }) => {

  const landContent = () => {
    return (
      <>
        Your notebook: The one place to keep each and every little detail perfectly organized.
        Need some ideas on making the most out of your notebook? You can find it all
        {' '}<a
          target="_blank"
          rel="noreferrer"
          href="https://help.aisleplanner.com/en/collections/72560-the-notebook"
        >
          <span>here</span>
        </a>.
      </>
    );
  };

  return (
    <LandingContent
      action={createNote}
      title="Get started with your notebook."
      description={landContent()}
      actionButtonTitle="Add a new note"
      heroImage={noteLandingImage}
    />
  );
};

export default NoteLanding;
